import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
    html,
    body {
        background-color: black; /* Set black background for both HTML and body */
        margin: 0;
        padding: 0;
        width: 100%;
        height: 100%;
        overflow: hidden;
    }

    #root {
        margin-top: 0.5em;
        margin-bottom: 0.01em;
        
        padding-top: 0.5em;
        padding-bottom: 0.1em;

        height: 100%;
    }

    body {
        font-family: -apple-system,BlinkMacSystemFont,Segoe UI,Helvetica,Arial,sans-serif,Apple Color Emoji,Segoe UI Emoji;
        line-height: 2.5;
        overflow: hidden;
        background-color: black;
    }

    *, *::before, *::after {
        box-sizing: border-box;
    }

    #root {
        display: "flex";
        font-size: 14px;
        color: #ccc;
        padding: 10px;
        background-color: rgb(0 0 0 / 90%);
    }

    ::-webkit-scrollbar {
        width: 5px;
    }

    ::-webkit-scrollbar-thumb {
        background-color: #999;
    }

    ::-webkit-scrollbar-thumb:hover {
        background-color: #ccc;
    }
`;
